import {IntlProvider, defineMessages, addLocaleData} from 'react-intl';

import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';

import 'moment/locale/de';

addLocaleData([
  ...en,
  ...de,
]);



// WEBPACK FOOTER //
// ./src/initLocales.js